import { render, staticRenderFns } from "./compnayVault.vue?vue&type=template&id=b7cf6dca"
import script from "./compnayVault.vue?vue&type=script&lang=js"
export * from "./compnayVault.vue?vue&type=script&lang=js"
import style0 from "./compnayVault.vue?vue&type=style&index=0&id=b7cf6dca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports